import React from 'react';
import {Container, Button, } from 'react-bootstrap';
import img1 from '../images/8401.jpg' ; 
export default function Section1() {
  return ( 
        <section className="row section1"> 
            <div className="container-fluid col-12 d-flex">
                <div className="intro col-sm-12 col-md-6 col-lg-6 ">
                    <Container>
                        <div >
                            <h5 >Ayza</h5> 
                        </div> 
                        <div style={{padding:'20px' }}>
                            <hr/>
                            <h1>Hey. I'm Ayza</h1>
                            <h6>Web Developer</h6>
                        </div>
                        <div >
                            <Button variant="outline-dark">
                                Hire Me
                            </Button>
                        </div>  
                    </Container>
                </div>
                <div className=" col-sm-12 col-md-6 col-lg-6 mx-auto ">
                    <img src={img1} alt="illustration" />
                </div>
            </div> 
        </section> 
  )
}
